import * as React from "react";
import { Spinner } from "react-ui";

import * as styles from "./MultiLineLoader.styles";

export function MultiLineLoader(props: { children: React.ReactNode; active: boolean }): JSX.Element {
    return props.active ? (
        <div css={styles.loader}>
            <div css={styles.loaderText}>
                <Spinner type="big" caption={""} />
                <div>{props.children}</div>
            </div>
        </div>
    ) : (
        <></>
    );
}
